// all mutations should be by companyID
import Vue from 'vue';


export default {
    updateHistory(state, payload){
        state.items = payload;
    },
    setLoading(state, payload){
        state.loading = payload;
    },
    setShowTable(state, payload){
      state.showTable = payload;
    },
    invalidate(state){
      state.items = null;
    }
    
}
